<template>
    <svg
        viewBox="0 0 73 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="73"
        height="92">
        <path
            d="M67 91H12C9.23858 91 7 88.7614 7 86V80.8662V53.9108V6C7 3.23858 9.23858 1 12 1H50.445L72 22.68V86C72 88.7614 69.7614 91 67 91Z"
            fill="url(#paint0_linear_2651_26425)"
            fill-opacity="0.8"
            stroke="#EEEEEE"
            stroke-width="2"
            class="fill-accent-600 transition-all duration-500 group-hover:fill-accent-600/70" />
        <rect
            x="1"
            y="53"
            rx="5"
            fill="url(#paint1_linear_2651_26425)"
            fill-opacity="0.8"
            width="53"
            height="26"
            class="transition-all duration-500 group-hover:-translate-y-3" />
        <rect
            x="1"
            y="53"
            rx="5"
            stroke="#EEEEEE"
            stroke-width="2"
            width="53"
            height="26"
            class="transition-all duration-500 group-hover:-translate-y-3" />
        <path
            d="M43.9236 61.2876H38.2725V65.1361H43.7321V67.2959H38.2725V72.8723H36.0695V59.1277H43.9236V61.2876Z"
            fill="#EEEEEE"
            class="transition-all duration-500 group-hover:-translate-y-3" />
        <path
            d="M27.6438 59.1277C29.4828 59.1277 31.0089 59.7887 32.2222 61.1108C33.4482 62.4329 34.0612 64.0627 34.0612 66C34.0612 67.9242 33.4482 69.554 32.2222 70.8892C31.0089 72.2113 29.4828 72.8723 27.6438 72.8723H22.3757V59.1277H27.6438ZM27.6438 70.7124C28.9081 70.7124 29.9362 70.2674 30.728 69.3772C31.5325 68.4871 31.9348 67.3614 31.9348 66C31.9348 64.6255 31.5325 63.4998 30.728 62.6227C29.9362 61.7326 28.9081 61.2876 27.6438 61.2876H24.5787V70.7124H27.6438Z"
            fill="#EEEEEE"
            class="transition-all duration-500 group-hover:-translate-y-3" />
        <path
            d="M16.0188 59.1277C17.2831 59.1277 18.3367 59.5597 19.1796 60.4236C20.0352 61.2876 20.4631 62.3609 20.4631 63.6438C20.4631 64.9135 20.0352 65.9869 19.1796 66.8639C18.3367 67.7279 17.2831 68.1599 16.0188 68.1599H13.2794V72.8723H11.0764V59.1277H16.0188ZM16.0188 66.0393C16.6701 66.0393 17.2065 65.8167 17.6279 65.3717C18.0493 64.9135 18.2601 64.3376 18.2601 63.6438C18.2601 62.95 18.0493 62.3806 17.6279 61.9355C17.2065 61.4774 16.6701 61.2483 16.0188 61.2483H13.2794V66.0393H16.0188Z"
            fill="#EEEEEE"
            class="transition-all duration-500 group-hover:-translate-y-3" />
        <defs>
            <linearGradient
                id="paint0_linear_2651_26425"
                x1="69.3868"
                y1="6.84524"
                x2="-2.79567"
                y2="28.4123"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#894BFF" />
                <stop
                    offset="1"
                    stop-color="#743FDA" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2651_26425"
                x1="52.0339"
                y1="54.0833"
                x2="12.9036"
                y2="85.6182"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#894BFF" />
                <stop
                    offset="1"
                    stop-color="#743FDA" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
